"use client";

import { useEffect } from "react";
import { useSearchParams } from "next/navigation";
import { captureCampaignAttribution } from "@/lib/campaign-attribution-client";
import { ANALYTICS_CONSENT_CHANGED_EVENT } from "@/lib/analytics-consent";

export function CampaignAttributionCapture() {
  const params = useSearchParams();
  const search = params.toString();
  useEffect(() => {
    const capture = () => captureCampaignAttribution(window.location.search);
    capture();
    window.addEventListener(ANALYTICS_CONSENT_CHANGED_EVENT, capture);
    return () => window.removeEventListener(ANALYTICS_CONSENT_CHANGED_EVENT, capture);
  }, [search]);
  return null;
}
